import React, { useState, useEffect } from "react";
import MenuSection from "../components/MenuSection";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useProductStore } from "../hooks/useProductStore";
import ArticulosListContainer from "../components/ArticulosListContainer";
import GrupoArticuloTabs from "../components/GrupoArticuloTabs";
import catalogo from "../api/catalogo";

// const grupoArticulo = [
//   { idCategoriaTotem: 1, descripcion: "PROMOCIONES", activo: 0 },
//   { idCategoriaTotem: 2, descripcion: "COMBOS", activo: 0 },
//   { idCategoriaTotem: 3, descripcion: "CAFETERIA", activo: 0 },
//   { idCategoriaTotem: 4, descripcion: "BEBIDAS", activo: 0 },
//   { idCategoriaTotem: 5, descripcion: "KIOSCO", activo: 0 },
//   { idCategoriaTotem: 6, descripcion: "PANADERIA", activo: 0 },
//   { idCategoriaTotem: 7, descripcion: "LICUADOS", activo: 0 },
//   { idCategoriaTotem: 8, descripcion: "HELADOS", activo: 0 },
// ];

const boxCardStyle = {
  display: "flex",
  backgroundColor: "#FFF",
  alignItems: "center",
  padding: "2px",
  marginBottom: "2px",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  height: "30px",
};

export const TiendaPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const innerWidth = window.innerWidth < 700;
  const [grupoArticulo, setGrupoArticulo] = useState([]);
  const [modalWidth, setModalWidth] = useState(window.innerWidth < 700 ? "360px" : "900px");
  const [disabled, setDisabled] = useState(false);
  const { idProductoArray, addProducto, setIdProductoArray } = useProductStore();
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState("0");

  // Estado para el grupo seleccionado
  const [selectedGrupo, setSelectedGrupo] = useState(grupoArticulo ? grupoArticulo[0]?.idCategoriaTotem : 1);

  // Función para obtener el color según el grupo seleccionado
  const getButtonColor = () => {
    // const selectedGroup = grupoArticulo.find(grupo => grupo.idCategoriaTotem === selectedGrupo);
    // if (selectedGroup && selectedGroup.descripcion === "HELADERA") {
    //   return "#8E5134";
    // }
    return theme.bandera.colorSecundario;
  };

  const refreshComanda = () => {
    const comanda = JSON.parse(localStorage.getItem("comanda") || "{}");
    const tieneDetalles = Array.isArray(comanda.comandaDetalles) && comanda.comandaDetalles.length > 0;
    setTotal(tieneDetalles ? comanda.importeFinal.toLocaleString().replace(".", "") : "0");
  };
  const handleAgregar = () => {
    const comandaLocal = JSON.parse(localStorage.getItem("comanda")) || [];
    const articulos = comandaLocal?.comandaDetalles || [];
    const totalArticulosConImporte = articulos.map(articulo => ({
      ...articulo,
      importe: articulo.cantidadArticulo * articulo.precioUnitario,
      descripcionPersonalizada: articulo.comentarios || "", // Guardar la observación como descripcionPersonalizada
    }));

    let idProductoArrayActual = idProductoArray;

    totalArticulosConImporte.forEach(articulo => {
      if (!articulo.idProductoArray) {
        articulo.idProductoArray = idProductoArrayActual;
        idProductoArrayActual += 1;
      }
      addProducto(articulo);
    });

    setIdProductoArray(idProductoArrayActual);

    localStorage.removeItem("comanda");
    navigate("/dashboard");
  };
  const handleGrupoSelect = idGrupoArticulo => {
    setSelectedGrupo(idGrupoArticulo);
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 700) {
        setModalWidth("360px");
      } else {
        setModalWidth("900px");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    refreshComanda();
  }, []);

  useEffect(() => {
    const fetchGrupoArticulo = async () => {
      setLoading(true);
      try {
        const response = await catalogo.getCatalogoItems();
        if (response && response.items.length > 0) {
          setGrupoArticulo(response.items);
          if (response.items.length > 0) {
            setSelectedGrupo(response.items[0].idCategoriaTotem);
          }
        } else {
          console.error("Error: La respuesta no es un array válido", response);
        }
      } catch (error) {
        console.error("Error al obtener los grupos de artículos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGrupoArticulo();
  }, []);

  return (
    <>
      <MenuSection dynamicColor={getButtonColor()} />
      {loading ? (
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <CircularProgress size={50} />
          <Typography variant="h6" sx={{ mt: 4 }}>
            Cargando grupos de artículos...
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            height: innerWidth ? "80%" : "50%",
            mt: innerWidth ? "1rem" : "-7rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            width: innerWidth ? "100%" : modalWidth,
            top: innerWidth ? "48%" : "56.5%",
          }}
        >
          {/* Tabs de grupos */}
          <GrupoArticuloTabs 
            grupoArticulo={grupoArticulo} 
            selectedGrupo={selectedGrupo} 
            onGrupoSelect={handleGrupoSelect} 
            innerWidth={innerWidth}
            dynamicColor={getButtonColor()}
          />{" "}
          
          <Box
            sx={{
              flexGrow: 1,
              mt: "-2rem",
              height: window.innerWidth < 700 ? 340 : 275,
            }}
          >
            <ArticulosListContainer grupoId={selectedGrupo} onComandaChange={refreshComanda} dynamicColor={getButtonColor()} />
          </Box>
          <Box sx={{ mt: 2 }}>
            <Box sx={boxCardStyle}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  textAlign: "start",
                  fontSize: "16px",
                  marginLeft: 1,
                }}
              >
                TOTAL:
                {Number(total).toLocaleString("es-ES", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: window.innerWidth < 700 ? "space-between" : "flex-end",
                width: "100%",
                p: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{
                  boxShadow: 0,
                  fontWeight: "bold",
                  fontSize: 17,
                  marginRight: !innerWidth ? 1 : 0,
                  backgroundColor: getButtonColor(),
                  ":hover": {
                    backgroundColor: getButtonColor(),
                  },
                }}
                onClick={() => {
                  localStorage.removeItem("comanda");
                  navigate(-1);
                }}
              >
                CANCELAR
              </Button>
              <Button
                variant="contained"
                disabled={disabled}
                sx={{
                  boxShadow: 0,
                  fontWeight: "bold",
                  fontSize: 17,
                  backgroundColor: getButtonColor(),
                  ":hover": {
                    backgroundColor: getButtonColor(),
                  },
                }}
                onClick={handleAgregar}
              >
                CONTINUAR
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
